import type { PagamentoResumoResponse } from './index'

/**
 * Mock do resumo de pagamento com 3 etapas para testar a tela de acompanhar pagamento.
 * Usar na URL: .../acompanharPagamento?p=mock
 */
export const resumoPagamentoMockEtapasV21: PagamentoResumoResponse = JSON.parse(`{
  "codigoProposta": "16552256969",
  "statusProposta": "Pendente",
  "pago": false,
  "procedimento": "Teste Pagamento",
  "medico": "Roger Rodrigues",
  "localAtendimento": "Hospital Santa Ana",
  "dadosPessoais": {
      "nome": "Theodoro Altissimo",
      "telefone": "61999637613",
      "email": "teste@teste.com",
      "documento": "04268287124",
      "pessoaJuridica": false,
      "cep": "71880055",
      "estado": "DF",
      "cidade": "Brasília",
      "endereco": "Quadra 1000 Bloco A",
      "ativo": true,    
      "propostaId": null
  },
  "paciente": {
      "nome": "Theodoro Altissimo",
      "cpf": "04268287124",
      "idade": 24
  },
  "valorTotal": 24750,
  "parcelamento": {
      "valorSemJuros": 24750,
      "parcelas": [
          {
              "qtdeParcelas": 1,
              "parceirosAssumiramJuros": null,
              "valor": 25621.2,
              "valorTotal": 25621.2,
              "valorSplit": 25168.126474496297,
              "juros": 3.52,
              "diasAntecipados": 28
          },
          {
              "qtdeParcelas": 2,
              "parceirosAssumiramJuros": null,
              "valor": 12998.7,
              "valorTotal": 25997.4,
              "valorSplit": 25390.257664096294,
              "juros": 2.52,
              "diasAntecipados": 57
          },
          {
              "qtdeParcelas": 3,
              "parceirosAssumiramJuros": null,
              "valor": 8725.2,
              "valorTotal": 26175.6,
              "valorSplit": 25621.58953925998,
              "juros": 1.92,
              "diasAntecipados": 87
          },
          {
              "qtdeParcelas": 4,
              "parceirosAssumiramJuros": null,
              "valor": 6662.7,
              "valorTotal": 26650.8,
              "valorSplit": 25866.52871184687,
              "juros": 1.92,
              "diasAntecipados": 119
          },
          {
              "qtdeParcelas": 5,
              "parceirosAssumiramJuros": null,
              "valor": 5425.2,
              "valorTotal": 27126,
              "valorSplit": 26106.934001670845,
              "juros": 1.92,
              "diasAntecipados": 147
          },
          {
              "qtdeParcelas": 6,
              "parceirosAssumiramJuros": null,
              "valor": 4600.2,
              "valorTotal": 27601.2,
              "valorSplit": 26352.6822949016,
              "juros": 1.92,
              "diasAntecipados": 177
          },
          {
              "qtdeParcelas": 7,
              "parceirosAssumiramJuros": null,
              "valor": 4010.9142857142856,
              "valorTotal": 28076.4,
              "valorSplit": 26608.434425759526,
              "juros": 1.92,
              "diasAntecipados": 209
          },
          {
              "qtdeParcelas": 8,
              "parceirosAssumiramJuros": null,
              "valor": 3568.95,
              "valorTotal": 28551.6,
              "valorSplit": 26868.27218916711,
              "juros": 1.92,
              "diasAntecipados": 239
          },
          {
              "qtdeParcelas": 9,
              "parceirosAssumiramJuros": null,
              "valor": 3225.2,
              "valorTotal": 29026.8,
              "valorSplit": 27128.683127237888,
              "juros": 1.92,
              "diasAntecipados": 267
          },
          {
              "qtdeParcelas": 10,
              "parceirosAssumiramJuros": null,
              "valor": 2950.2,
              "valorTotal": 29502,
              "valorSplit": 27394.54116265015,
              "juros": 1.92,
              "diasAntecipados": 297
          },
          {
              "qtdeParcelas": 11,
              "parceirosAssumiramJuros": null,
              "valor": 2725.2,
              "valorTotal": 29977.2,
              "valorSplit": 27669.257600026016,
              "juros": 1.92,
              "diasAntecipados": 329
          },
          {
              "qtdeParcelas": 12,
              "parceirosAssumiramJuros": null,
              "valor": 2537.7,
              "valorTotal": 30452.4,
              "valorSplit": 27949.170778530268,
              "juros": 1.92,
              "diasAntecipados": 359
          }
      ]
  },
  "valorPago": 0,
  "valorEmProcessamento": 0,
  "saldoDevedor": 18250,
  "dadosRecebedorIncompleto": false,  
  "etapaAtual": 0,
  "existeEtapasDB": false,
  "versaoPagamento": "v2.1",
  "etapas": [
      {
          "titulo": "Confirmação inicial",
          "descricao": "Nesta primeira etapa, você realiza a entrada para confirmar o agendamento da cirurgia.\\n- Esse valor pode ser pago à vista ou parcelado\\n- Se optar por parcelar, haverá cobrança de juros\\n- A confirmação garante o bloqueio de agenda, estrutura e materiais necessários",
          "parceiros": [
              {
                  "recebedorId": "d4c7af6c-e1a6-48ed-9f9a-c7b75027aa59",
                  "tipoRecebedor": "M",
                  "valor": 12000
              },
              {
                  "recebedorId": "16d70d80-ff70-4a9e-8b88-66e50c56211b",
                  "tipoRecebedor": "FA",
                  "valor": 4000
              },
              {
                  "recebedorId": "00000000-0000-0000-0000-000000000000",
                  "tipoRecebedor": "SYN",
                  "valor": 2250
              }
          ],
          "pedidos": [],
          "valor": 18250,
          "saldoDevedor": 18250,
          "status": "Pendente",
          "valorEmProcessamento": 0,
          "valorPago": 0
      },
      {
          "titulo": "Finalização do pagamento",
           
          "parceiros": [
              {
                  "recebedorId": "59b42a39-1538-4383-b3be-9e19c10bdcd9",
                  "tipoRecebedor": "P",
                  "valor": 1500
              },
              {
                  "recebedorId": "59b42a39-1538-4383-b3be-9e19c10bdcd9",
                  "tipoRecebedor": "P",
                  "valor": 5000
              }
          ],
          "pedidos": [],
          "valor": 6500,
          "saldoDevedor": 6500,
          "status": "Pendente",
          "valorEmProcessamento": 0,
          "valorPago": 0
      }
  ]
}`)

export const resumoPagamentoMockEtapasV212: PagamentoResumoResponse = JSON.parse(`{
  "codigoProposta": "16552256969",
  "statusProposta": "Pendente",
  "pago": false,
  "procedimento": "Teste Pagamento",
  "medico": "Roger Rodrigues",
  "localAtendimento": "Hospital Santa Ana",
  "dadosPessoais": {
      "nome": "Theodoro Altissimo",
      "telefone": "61999637613",
      "email": "teste@teste.com",
      "documento": "04268287124",
      "pessoaJuridica": false,
      "cep": "71880055",
      "estado": "DF",
      "cidade": "Brasília",
      "endereco": "Quadra 1000 Bloco A",
      "ativo": true,
      "propostaId": null
  },
  "paciente": {
      "nome": "Theodoro Altissimo",
      "cpf": "04268287124",
      "idade": 24
  },
  "valorTotal": 24750,
  "parcelamento": {
      "valorSemJuros": 24750,
      "parcelas": [
          {
              "qtdeParcelas": 1,
              "parceirosAssumiramJuros": null,
              "valor": 25621.2,
              "valorTotal": 25621.2,
              "valorSplit": 25168.126474496297,
              "juros": 3.52,
              "diasAntecipados": 28
          },
          {
              "qtdeParcelas": 2,
              "parceirosAssumiramJuros": null,
              "valor": 12998.7,
              "valorTotal": 25997.4,
              "valorSplit": 25390.257664096294,
              "juros": 2.52,
              "diasAntecipados": 57
          },
          {
              "qtdeParcelas": 3,
              "parceirosAssumiramJuros": null,
              "valor": 8725.2,
              "valorTotal": 26175.6,
              "valorSplit": 25621.58953925998,
              "juros": 1.92,
              "diasAntecipados": 87
          },
          {
              "qtdeParcelas": 4,
              "parceirosAssumiramJuros": null,
              "valor": 6662.7,
              "valorTotal": 26650.8,
              "valorSplit": 25866.52871184687,
              "juros": 1.92,
              "diasAntecipados": 119
          },
          {
              "qtdeParcelas": 5,
              "parceirosAssumiramJuros": null,
              "valor": 5425.2,
              "valorTotal": 27126,
              "valorSplit": 26106.934001670845,
              "juros": 1.92,
              "diasAntecipados": 147
          },
          {
              "qtdeParcelas": 6,
              "parceirosAssumiramJuros": null,
              "valor": 4600.2,
              "valorTotal": 27601.2,
              "valorSplit": 26352.6822949016,
              "juros": 1.92,
              "diasAntecipados": 177
          },
          {
              "qtdeParcelas": 7,
              "parceirosAssumiramJuros": null,
              "valor": 4010.9142857142856,
              "valorTotal": 28076.4,
              "valorSplit": 26608.434425759526,
              "juros": 1.92,
              "diasAntecipados": 209
          },
          {
              "qtdeParcelas": 8,
              "parceirosAssumiramJuros": null,
              "valor": 3568.95,
              "valorTotal": 28551.6,
              "valorSplit": 26868.27218916711,
              "juros": 1.92,
              "diasAntecipados": 239
          },
          {
              "qtdeParcelas": 9,
              "parceirosAssumiramJuros": null,
              "valor": 3225.2,
              "valorTotal": 29026.8,
              "valorSplit": 27128.683127237888,
              "juros": 1.92,
              "diasAntecipados": 267
          },
          {
              "qtdeParcelas": 10,
              "parceirosAssumiramJuros": null,
              "valor": 2950.2,
              "valorTotal": 29502,
              "valorSplit": 27394.54116265015,
              "juros": 1.92,
              "diasAntecipados": 297
          },
          {
              "qtdeParcelas": 11,
              "parceirosAssumiramJuros": null,
              "valor": 2725.2,
              "valorTotal": 29977.2,
              "valorSplit": 27669.257600026016,
              "juros": 1.92,
              "diasAntecipados": 329
          },
          {
              "qtdeParcelas": 12,
              "parceirosAssumiramJuros": null,
              "valor": 2537.7,
              "valorTotal": 30452.4,
              "valorSplit": 27949.170778530268,
              "juros": 1.92,
              "diasAntecipados": 359
          }
      ]
  },
  "valorPago": 0,
  "valorEmProcessamento": 0,
  "saldoDevedor": 18250,
  "dadosRecebedorIncompleto": false,  
  "etapaAtual": 1,
  "existeEtapasDB": true,
  "versaoPagamento": "v2.1",
  "etapas": [
      {
          "titulo": "Confirmação inicial",
          "descricao": "Nesta primeira etapa, você realiza a entrada para confirmar o agendamento da cirurgia.\\n- Esse valor pode ser pago à vista ou parcelado\\n- Se optar por parcelar, haverá cobrança de juros\\n- A confirmação garante o bloqueio de agenda, estrutura e materiais necessários",
          "parceiros": [
              {
                  "recebedorId": "d4c7af6c-e1a6-48ed-9f9a-c7b75027aa59",
                  "tipoRecebedor": "M",
                  "valor": 12000
              },
              {
                  "recebedorId": "16d70d80-ff70-4a9e-8b88-66e50c56211b",
                  "tipoRecebedor": "FA",
                  "valor": 4000
              },
              {
                  "recebedorId": "00000000-0000-0000-0000-000000000000",
                  "tipoRecebedor": "SYN",
                  "valor": 2250
              }
          ],
          "pedidos": [],
          "valor": 18250,
          "saldoDevedor": 18250,
          "status": "Pendente",
          "valorEmProcessamento": 0,
          "valorPago": 18250
      },
      {
          "titulo": "Finalização do pagamento",
          "descricao": "Na última etapa, você conclui o pagamento restante da cirurgia.\\n- Essa parte pode ser parcelada em até 10 vezes sem juros\\n- O pagamento é feito com total transparência\\n- Ao final, todo o valor do procedimento estará quitado",
          "parceiros": [
              {
                  "recebedorId": "59b42a39-1538-4383-b3be-9e19c10bdcd9",
                  "tipoRecebedor": "P",
                  "valor": 1500
              },
              {
                  "recebedorId": "59b42a39-1538-4383-b3be-9e19c10bdcd9",
                  "tipoRecebedor": "P",
                  "valor": 5000
              }
          ],
          "pedidos": [],
          "valor": 6500,
          "saldoDevedor": 6500,
          "status": "Pendente",
          "valorEmProcessamento": 0,
          "valorPago": 1000
      }
  ]
}`)

export const resumoPagamentoMockEtapasV2: PagamentoResumoResponse = JSON.parse(`{
    "codigoProposta": "16552256817",
    "statusProposta": "Pendente",
    "pago": false,
    "procedimento": "Cirurgia Orçamento Teste Velva",
    "medico": "Dr Thiago Teste",
    "localAtendimento": "Hospital Santa Ana",
    "dadosPessoais": {
        "nome": "Thiago Teste",
        "telefone": "61982370632",
        "email": "analistadequalidade@synsaude.com.br",
        "documento": "05869344131",
        "pessoaJuridica": false,
        "cep": "73330006",
        "estado": "BR-DF",
        "cidade": "Brasília",
        "endereco": "Avenida Independência",
        "ativo": true,
        "propostaId": "f11a15ce-ed8e-4283-9b7b-b4d7085605a4"
    },
    "paciente": {
        "nome": "Thiago Teste",
        "cpf": "05869344131",
        "idade": 25
    },
    "valorTotal": 2910.60,
    "parcelamento": {
        "valorSemJuros": 2910.60,
        "parcelas": [
            {
                "qtdeParcelas": 1,
                "parceirosAssumiramJuros": null,
                "valor": 3013.05312,
                "valorTotal": 3013.05312,
                "valorSplit": 2965.1387860718142365237943234,
                "juros": 3.52,
                "diasAntecipados": 31
            },
            {
                "qtdeParcelas": 2,
                "parceirosAssumiramJuros": null,
                "valor": 1528.64712,
                "valorTotal": 3057.29424,
                "valorSplit": 2992.2689951064383918413224952,
                "juros": 2.52,
                "diasAntecipados": 61
            },
            {
                "qtdeParcelas": 3,
                "parceirosAssumiramJuros": null,
                "valor": 1026.08352,
                "valorTotal": 3078.25056,
                "valorSplit": 3018.6613688691399452857975851,
                "juros": 1.92,
                "diasAntecipados": 89
            },
            {
                "qtdeParcelas": 4,
                "parceirosAssumiramJuros": null,
                "valor": 783.53352,
                "valorTotal": 3134.13408,
                "valorSplit": 3046.1538461538461538461538463,
                "juros": 1.92,
                "diasAntecipados": 119
            },
            {
                "qtdeParcelas": 5,
                "parceirosAssumiramJuros": null,
                "valor": 638.00352,
                "valorTotal": 3190.0176,
                "valorSplit": 3075.1795069739005241871295932,
                "juros": 1.92,
                "diasAntecipados": 151
            },
            {
                "qtdeParcelas": 6,
                "parceirosAssumiramJuros": null,
                "valor": 540.98352,
                "valorTotal": 3245.90112,
                "valorSplit": 3103.9778180654793644022608509,
                "juros": 1.92,
                "diasAntecipados": 179
            },
            {
                "qtdeParcelas": 7,
                "parceirosAssumiramJuros": null,
                "valor": 471.68352,
                "valorTotal": 3301.78464,
                "valorSplit": 3133.4349742497147116511454084,
                "juros": 1.92,
                "diasAntecipados": 209
            },
            {
                "qtdeParcelas": 8,
                "parceirosAssumiramJuros": null,
                "valor": 419.70852,
                "valorTotal": 3357.66816,
                "valorSplit": 3164.0395695184259158604196109,
                "juros": 1.92,
                "diasAntecipados": 241
            },
            {
                "qtdeParcelas": 9,
                "parceirosAssumiramJuros": null,
                "valor": 379.28352,
                "valorTotal": 3413.55168,
                "valorSplit": 3194.9506037321624588364434688,
                "juros": 1.92,
                "diasAntecipados": 270
            },
            {
                "qtdeParcelas": 10,
                "parceirosAssumiramJuros": null,
                "valor": 346.94352,
                "valorTotal": 3469.4352,
                "valorSplit": 3226.2593673401372558727615743,
                "juros": 1.92,
                "diasAntecipados": 299
            },
            {
                "qtdeParcelas": 11,
                "parceirosAssumiramJuros": null,
                "valor": 320.48352,
                "valorTotal": 3525.31872,
                "valorSplit": 3258.2271679382994630783238057,
                "juros": 1.92,
                "diasAntecipados": 329
            },
            {
                "qtdeParcelas": 12,
                "parceirosAssumiramJuros": null,
                "valor": 298.43352,
                "valorTotal": 3581.20224,
                "valorSplit": 3291.2329150932669275405838191,
                "juros": 1.92,
                "diasAntecipados": 361
            }
        ]
    },
    "valorPago": 1999.00,
    "valorEmProcessamento": 499.00,
    "saldoDevedor": 911.60,
    "dadosRecebedorIncompleto": false,
    
    "etapaAtual": 0,
    "existeEtapasDB": false,
    "versaoPagamento": "v2",
    "etapas": [
      {
          "titulo": "Confirmação inicial",
          "parceiros": [
              {
                  "recebedorId": "d4c7af6c-e1a6-48ed-9f9a-c7b75027aa59",
                  "tipoRecebedor": "M",
                  "valor": 12000
              },
              {
                  "recebedorId": "16d70d80-ff70-4a9e-8b88-66e50c56211b",
                  "tipoRecebedor": "FA",
                  "valor": 4000
              },
              {
                  "recebedorId": "00000000-0000-0000-0000-000000000000",
                  "tipoRecebedor": "SYN",
                  "valor": 2250
              }
          ],
          "pedidos": [
          {
              "id": "9ac5a726-048a-4594-951c-dad993188693",
              "criado": "2026-02-10T17:51:42.4600746",
              "modificado": "2026-02-10T17:51:42.4600747",
              "integral": false,
              "status": "pago",
              "valor": 500.00,
              "juros": 22.73,
              "tipo": "cartão de crédito",
              "urlBoleto": null,
              "pixCopiaCola": null,
              "urlQrCode": null,
              "codigoBoleto": null,
              "dataPagamento": "2026-02-10T17:51:42",
              "formaPagamento": "credit_card",
              "tipoPagamento": null,
              "codigoEstabelecimento": null,
              "urlComprovante": null,
              "registroManual": false,
              "motivoRecusa": null,
              "criadaPor": "Ana Lemos",
              "modificadoPor": null
          },
          {
              "id": "de779c92-2d37-4303-a741-db6f750327c4",
              "criado": "2026-02-10T17:48:38.1189884",
              "modificado": "2026-02-10T17:48:38.1189884",
              "integral": false,
              "status": "pendente",
              "valor": 499.00,
              "juros": 0.00,
              "tipo": "pix",
              "urlBoleto": null,
              "pixCopiaCola": "https://digital.mundipagg.com/pix/",
              "urlQrCode": "https://api.pagar.me/core/v5/transactions/tran_l4EWVQvGC4t4w5yA/qrcode?payment_method=pix",
              "codigoBoleto": null,
              "dataPagamento": "2026-02-10T17:48:38.1189884",
              "formaPagamento": "pix",
              "tipoPagamento": null,
              "codigoEstabelecimento": null,
              "urlComprovante": null,
              "registroManual": false,
              "motivoRecusa": null,
              "criadaPor": "Ana Lemos",
              "modificadoPor": null
          },
          {
              "id": "7bad6ffe-8eb8-464c-8b42-fbec86b6b521",
              "criado": "2026-02-06T17:24:28.0336706",
              "modificado": "2026-02-06T17:24:28.0336707",
              "integral": false,
              "status": "pago",
              "valor": 499.00,
              "juros": 0.00,
              "tipo": "pix",
              "urlBoleto": null,
              "pixCopiaCola": "https://digital.mundipagg.com/pix/",
              "urlQrCode": "https://api.pagar.me/core/v5/transactions/tran_g6qaq8QI03c2PxM2/qrcode?payment_method=pix",
              "codigoBoleto": null,
              "dataPagamento": "2026-02-06T17:24:27",
              "formaPagamento": "pix",
              "tipoPagamento": null,
              "codigoEstabelecimento": null,
              "urlComprovante": null,
              "registroManual": false,
              "motivoRecusa": null,
              "criadaPor": "Ana Lemos",
              "modificadoPor": null
          },
          {
              "id": "e9ec1238-a259-475c-8ba1-c4e4f7f61ebf",
              "criado": "2025-12-19T13:20:12.3651459",
              "modificado": "2025-12-19T13:20:12.3651461",
              "integral": false,
              "status": "pago",
              "valor": 1000.00,
              "juros": 34.42,
              "tipo": "cartão de crédito",
              "urlBoleto": null,
              "pixCopiaCola": null,
              "urlQrCode": null,
              "codigoBoleto": null,
              "dataPagamento": "2025-12-19T13:20:11",
              "formaPagamento": "credit_card",
              "tipoPagamento": null,
              "codigoEstabelecimento": null,
              "urlComprovante": null,
              "registroManual": false,
              "motivoRecusa": null,
              "criadaPor": "Ana Lemos",
              "modificadoPor": null
          }],
          "valor": 18250,
          "saldoDevedor": 18250,
          "status": "Pendente",
          "valorEmProcessamento": 0,
          "valorPago": 0
         
        }]
}`)

export const resumoPagamentoMockEtapasV1: PagamentoResumoResponse = JSON.parse(`{
    "codigoProposta": "16552256817",
    "statusProposta": "Pendente",
    "pago": false,
    "procedimento": "Cirurgia Orçamento Teste Velva",
    "medico": "Dr Thiago Teste",
    "localAtendimento": "Hospital Santa Ana",
    "dadosPessoais": {
        "nome": "Thiago Teste",
        "telefone": "61982370632",
        "email": "analistadequalidade@synsaude.com.br",
        "documento": "05869344131",
        "pessoaJuridica": false,
        "cep": "73330006",
        "estado": "BR-DF",
        "cidade": "Brasília",
        "endereco": "Avenida Independência",
        "ativo": true,
        "propostaId": "f11a15ce-ed8e-4283-9b7b-b4d7085605a4"
    },
    "paciente": {
        "nome": "Thiago Teste",
        "cpf": "05869344131",
        "idade": 25
    },
    "valorTotal": 2910.60,
    "parcelamento": {
        "valorSemJuros": 2910.60,
        "parcelas": [
            {
                "qtdeParcelas": 1,
                "parceirosAssumiramJuros": null,
                "valor": 3013.05312,
                "valorTotal": 3013.05312,
                "valorSplit": 2965.1387860718142365237943234,
                "juros": 3.52,
                "diasAntecipados": 31
            },
            {
                "qtdeParcelas": 2,
                "parceirosAssumiramJuros": null,
                "valor": 1528.64712,
                "valorTotal": 3057.29424,
                "valorSplit": 2992.2689951064383918413224952,
                "juros": 2.52,
                "diasAntecipados": 61
            },
            {
                "qtdeParcelas": 3,
                "parceirosAssumiramJuros": null,
                "valor": 1026.08352,
                "valorTotal": 3078.25056,
                "valorSplit": 3018.6613688691399452857975851,
                "juros": 1.92,
                "diasAntecipados": 89
            },
            {
                "qtdeParcelas": 4,
                "parceirosAssumiramJuros": null,
                "valor": 783.53352,
                "valorTotal": 3134.13408,
                "valorSplit": 3046.1538461538461538461538463,
                "juros": 1.92,
                "diasAntecipados": 119
            },
            {
                "qtdeParcelas": 5,
                "parceirosAssumiramJuros": null,
                "valor": 638.00352,
                "valorTotal": 3190.0176,
                "valorSplit": 3075.1795069739005241871295932,
                "juros": 1.92,
                "diasAntecipados": 151
            },
            {
                "qtdeParcelas": 6,
                "parceirosAssumiramJuros": null,
                "valor": 540.98352,
                "valorTotal": 3245.90112,
                "valorSplit": 3103.9778180654793644022608509,
                "juros": 1.92,
                "diasAntecipados": 179
            },
            {
                "qtdeParcelas": 7,
                "parceirosAssumiramJuros": null,
                "valor": 471.68352,
                "valorTotal": 3301.78464,
                "valorSplit": 3133.4349742497147116511454084,
                "juros": 1.92,
                "diasAntecipados": 209
            },
            {
                "qtdeParcelas": 8,
                "parceirosAssumiramJuros": null,
                "valor": 419.70852,
                "valorTotal": 3357.66816,
                "valorSplit": 3164.0395695184259158604196109,
                "juros": 1.92,
                "diasAntecipados": 241
            },
            {
                "qtdeParcelas": 9,
                "parceirosAssumiramJuros": null,
                "valor": 379.28352,
                "valorTotal": 3413.55168,
                "valorSplit": 3194.9506037321624588364434688,
                "juros": 1.92,
                "diasAntecipados": 270
            },
            {
                "qtdeParcelas": 10,
                "parceirosAssumiramJuros": null,
                "valor": 346.94352,
                "valorTotal": 3469.4352,
                "valorSplit": 3226.2593673401372558727615743,
                "juros": 1.92,
                "diasAntecipados": 299
            },
            {
                "qtdeParcelas": 11,
                "parceirosAssumiramJuros": null,
                "valor": 320.48352,
                "valorTotal": 3525.31872,
                "valorSplit": 3258.2271679382994630783238057,
                "juros": 1.92,
                "diasAntecipados": 329
            },
            {
                "qtdeParcelas": 12,
                "parceirosAssumiramJuros": null,
                "valor": 298.43352,
                "valorTotal": 3581.20224,
                "valorSplit": 3291.2329150932669275405838191,
                "juros": 1.92,
                "diasAntecipados": 361
            }
        ]
    },
    "valorPago": 1999.00,
    "valorEmProcessamento": 499.00,
    "saldoDevedor": 911.60,
    "dadosRecebedorIncompleto": false,
    
    "etapaAtual": 0,
    "existeEtapasDB": false,
    "versaoPagamento": "v1",
    "etapas": [
      {
          "titulo": "Confirmação inicial",
          "parceiros": [
              {
                  "recebedorId": "d4c7af6c-e1a6-48ed-9f9a-c7b75027aa59",
                  "tipoRecebedor": "M",
                  "valor": 12000
              },
              {
                  "recebedorId": "16d70d80-ff70-4a9e-8b88-66e50c56211b",
                  "tipoRecebedor": "FA",
                  "valor": 4000
              },
              {
                  "recebedorId": "00000000-0000-0000-0000-000000000000",
                  "tipoRecebedor": "SYN",
                  "valor": 2250
              }
          ],
          "pedidos": [
          {
              "id": "9ac5a726-048a-4594-951c-dad993188693",
              "criado": "2026-02-10T17:51:42.4600746",
              "modificado": "2026-02-10T17:51:42.4600747",
              "integral": false,
              "status": "pago",
              "valor": 500.00,
              "juros": 22.73,
              "tipo": "cartão de crédito",
              "urlBoleto": null,
              "pixCopiaCola": null,
              "urlQrCode": null,
              "codigoBoleto": null,
              "dataPagamento": "2026-02-10T17:51:42",
              "formaPagamento": "credit_card",
              "tipoPagamento": null,
              "codigoEstabelecimento": null,
              "urlComprovante": null,
              "registroManual": false,
              "motivoRecusa": null,
              "criadaPor": "Ana Lemos",
              "modificadoPor": null
          },
          {
              "id": "de779c92-2d37-4303-a741-db6f750327c4",
              "criado": "2026-02-10T17:48:38.1189884",
              "modificado": "2026-02-10T17:48:38.1189884",
              "integral": false,
              "status": "pendente",
              "valor": 499.00,
              "juros": 0.00,
              "tipo": "pix",
              "urlBoleto": null,
              "pixCopiaCola": "https://digital.mundipagg.com/pix/",
              "urlQrCode": "https://api.pagar.me/core/v5/transactions/tran_l4EWVQvGC4t4w5yA/qrcode?payment_method=pix",
              "codigoBoleto": null,
              "dataPagamento": "2026-02-10T17:48:38.1189884",
              "formaPagamento": "pix",
              "tipoPagamento": null,
              "codigoEstabelecimento": null,
              "urlComprovante": null,
              "registroManual": false,
              "motivoRecusa": null,
              "criadaPor": "Ana Lemos",
              "modificadoPor": null
          },
          {
              "id": "7bad6ffe-8eb8-464c-8b42-fbec86b6b521",
              "criado": "2026-02-06T17:24:28.0336706",
              "modificado": "2026-02-06T17:24:28.0336707",
              "integral": false,
              "status": "pago",
              "valor": 499.00,
              "juros": 0.00,
              "tipo": "pix",
              "urlBoleto": null,
              "pixCopiaCola": "https://digital.mundipagg.com/pix/",
              "urlQrCode": "https://api.pagar.me/core/v5/transactions/tran_g6qaq8QI03c2PxM2/qrcode?payment_method=pix",
              "codigoBoleto": null,
              "dataPagamento": "2026-02-06T17:24:27",
              "formaPagamento": "pix",
              "tipoPagamento": null,
              "codigoEstabelecimento": null,
              "urlComprovante": null,
              "registroManual": false,
              "motivoRecusa": null,
              "criadaPor": "Ana Lemos",
              "modificadoPor": null
          },
          {
              "id": "e9ec1238-a259-475c-8ba1-c4e4f7f61ebf",
              "criado": "2025-12-19T13:20:12.3651459",
              "modificado": "2025-12-19T13:20:12.3651461",
              "integral": false,
              "status": "pago",
              "valor": 1000.00,
              "juros": 34.42,
              "tipo": "cartão de crédito",
              "urlBoleto": null,
              "pixCopiaCola": null,
              "urlQrCode": null,
              "codigoBoleto": null,
              "dataPagamento": "2025-12-19T13:20:11",
              "formaPagamento": "credit_card",
              "tipoPagamento": null,
              "codigoEstabelecimento": null,
              "urlComprovante": null,
              "registroManual": false,
              "motivoRecusa": null,
              "criadaPor": "Ana Lemos",
              "modificadoPor": null
          }],
          "valor": 18250,
          "saldoDevedor": 18250,
          "status": "Pendente",
          "valorEmProcessamento": 0,
          "valorPago": 0
         
        }]
}`)
